import { useState, useEffect } from 'react';

export function SplashScreen({ onComplete }) {
  const [fadeOut, setFadeOut] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    // Start fade out after 2 seconds
    const fadeTimer = setTimeout(() => {
      setFadeOut(true);
    }, 2000);

    // Complete and hide after fade animation (0.5s)
    const hideTimer = setTimeout(() => {
      setHidden(true);
      onComplete?.();
    }, 2500);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, [onComplete]);

  if (hidden) return null;

  return (
    <div 
      className={`splash-screen ${fadeOut ? 'splash-fade-out' : ''}`}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(180deg, #050505 0%, #0a0a0a 50%, #050505 100%)',
      }}
    >
      {/* Animated background glow */}
      <div className="splash-glow" />
      
      {/* Logo container with animations */}
      <div className="splash-logo-container">
        {/* Logo image */}
        <img 
          src="/logo.png" 
          alt="Vault Ride" 
          className="splash-logo"
        />
        
        {/* Text logo */}
        <h1 className="splash-title">
          VAULT RIDE
        </h1>
        
        {/* Subtitle */}
        <p className="splash-subtitle">
          GARAGE MANAGER
        </p>
      </div>
      
      {/* Loading indicator */}
      <div className="splash-loader">
        <div className="splash-loader-bar" />
      </div>
      
      {/* Version */}
      <p className="splash-version">v2.0</p>
    </div>
  );
}
